
export const getDeviceLang = (): string => {
  const appLanguage = 'en'

  return appLanguage.search(/-|_/) !== -1
    ? appLanguage.slice(0, 2)
    : appLanguage
}

export const USER_LANG = 'user_lang'
